(function () {
  // Auto-add the welcome-gift item when WELCOME30 is applied and the qualifying subtotal hits the threshold.
  // IMPORTANT: Shopify's Buy X Get Y discount only reports "applicable: true" on the /cart.js discount_codes
  // array AFTER the free item is already present in the cart — it does not pre-validate an empty cart.
  // So we must check for the CODE'S PRESENCE only (not its "applicable" flag) before adding the item;
  // Shopify will flip "applicable" to true itself once the item is there and conditions are met.
  // The item's actual price (and whether it's genuinely free) is still fully controlled by the real
  // Buy X Get Y discount in Shopify — this script only saves the customer the manual "add to cart" step.
  var GIFT_VARIANT_ID = 58513862394237; // "Free Kneemelters Qty 4" variant
  var DISCOUNT_CODE = 'WELCOME30';
  var THRESHOLD_CENTS = 3000; // £30.00

  function getCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) {
      return r.json();
    });
  }

  function addGift() {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: GIFT_VARIANT_ID, quantity: 1 }] }),
    });
  }

  function removeGift(lineKey) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: lineKey, quantity: 0 }),
    });
  }

  getCart()
    .then(function (cart) {
      // Check the CODE IS PRESENT on the cart — do NOT gate on "applicable", which Shopify only
      // flips to true after the gift item is already in the cart (chicken-and-egg).
      var hasCode = (cart.discount_codes || []).some(function (d) {
        return d.code && d.code.toUpperCase() === DISCOUNT_CODE;
      });

      var giftItem = cart.items.find(function (item) {
        return item.variant_id === GIFT_VARIANT_ID;
      });

      var qualifyingSubtotal = cart.items.reduce(function (sum, item) {
        if (item.variant_id === GIFT_VARIANT_ID) return sum;
        return sum + item.line_price;
      }, 0);

      var qualifies = hasCode && qualifyingSubtotal >= THRESHOLD_CENTS;

      if (qualifies && !giftItem) {
        addGift().then(function () {
          window.location.reload();
        });
      } else if (!qualifies && giftItem) {
        removeGift(giftItem.key).then(function () {
          window.location.reload();
        });
      }
    })
    .catch(function (err) {
      console.error('Welcome gift auto-add error:', err);
    });
})();
